module.exports = __webpack_public_path__ + "media/estera_separadora_entulho_geresol_P-10G.86e8e259.jpg";